import { motion } from 'framer-motion';
import styles from '../Settings.module.css';

export interface ChipOption<T extends string | number> {
  label: string;
  value: T;
}

export interface ChipGroupProps<T extends string | number> {
  options: ChipOption<T>[];
  value: T;
  onChange: (value: T) => void;
  label: string;
}

export function ChipGroup<T extends string | number>({
  options,
  value,
  onChange,
  label,
}: ChipGroupProps<T>) {
  return (
    <div className={styles.chipGroup} role="radiogroup" aria-label={label}>
      {options.map((option) => (
        <motion.button
          key={String(option.value)}
          type="button"
          role="radio"
          aria-checked={value === option.value}
          className={`${styles.chip} ${value === option.value ? styles.active : ''}`}
          onClick={() => onChange(option.value)}
          whileHover={{ scale: 1.02 }}
          whileTap={{ scale: 0.98 }}
        >
          {option.label}
        </motion.button>
      ))}
    </div>
  );
}
